/**
 * - カスタムイベントを発行する。
 * - CustomEventに対応していないブラウザで失敗した場合、
 * 別の処理にフォールバックさせる。
 * @param eventName カスタムイベント名
 * @param detail イベントの引数
 */
export const createCustomEvent = (eventName: string, detail: unknown): void => {
  let event: CustomEvent
  try {
    event = new CustomEvent(eventName, {
    // detailは固定プロパティ
      detail: detail
    })
  } catch (e) {
    // CustomEvent未対応ブラウザ用処理
    event = document.createEvent('CustomEvent')
    event.initCustomEvent(eventName, false, false, detail)
  }
  document.dispatchEvent(event)
}
